import {SOCKET_EVENT, useSocket} from "./SocketProvider";
import {useEffect, useState} from "react";
import {useAuth} from "../../authprovider";
import {Button, Modal} from "react-bootstrap";
import { useTranslation } from 'react-i18next';


export default function PushNotification(){
    const {socket} = useSocket()
    const auth = useAuth()
    const [buildingNames, setBuildingNames] = useState(undefined)
    const [push, setPush] = useState({
        show:false,
        building_id:undefined,
        text:undefined
    })
    const { t } = useTranslation();


    useEffect(()=>{

        socket.on(SOCKET_EVENT.ON_PUSH, function(d){
            if(d.building_id !== auth.user.building && auth.user.buildings.indexOf(d.building_id) > -1)
                setPush({show:true, text:d.text, building_id: d.building_id})
        })

        if(buildingNames === undefined)
            auth.buildings.get(({success, content})=>{
                if(!success) return


                 setBuildingNames(content.filter(c=>auth.user.buildings.indexOf(c.id)>-1 ).map(b=> {
                     return {id: b.id, name: b.name}
                 }))
            })


        return function cleanup(){
            socket.off(SOCKET_EVENT.ON_PUSH);
        }

    })


    const hide = ()=>{
        setPush({show:false, text: undefined, building_id: undefined})
    }


    return (
        <>
            {
                buildingNames &&
                <Modal className={""}
                       show={push.show}
                >
                    <Modal.Header >
                        <Modal.Title>{buildingNames.find(bn=>bn.id === push.building_id)?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            {push.text}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button name={"Zamknij"} className={"w-50"} variant="danger" onClick={hide} >
                            {t('push.close')}
                        </Button>
                    </Modal.Footer>
                    {/*<audio id="audio" preload="true" autoPlay={true}  hidden={true} loop={true}>*/}
                    {/*    <source src="audio/TF021.WAV" type="audio/wav" />*/}
                    {/*</audio>*/}
                </Modal>
            }

        </>
    )
}